// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__7hioO","priceAmount":"Price_priceAmount__xlNof","compareAtPriceAmount":"Price_compareAtPriceAmount__qw_kL"};